var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingCurveLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 11,
    viewBox: "0 0 53 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5891 11C20.5402 11.0003 18.122 8.96651 15.7545 6.97644C13.9594 5.4674 12.097 3.9244 9.94721 3.16319C3.38643 0.84036 0.0299684 5.08174 0 5.11929V3.82905C0.0355669 3.78496 0.634276 3.01395 2.36619 2.27789C3.94365 1.60746 6.58943 1.07287 10.239 2.33209C12.5512 3.12923 14.4715 4.74342 16.3285 6.30503C20.0956 9.47235 23.3494 12.2073 28.9992 7.92314C33.2788 4.6781 37.313 1.5859 41.2817 0.456326C45.1644 -0.649082 49.2118 0.160135 53 3.91689L52.9723 5.08859C44.9247 -2.92685 38.0721 2.15151 29.5387 8.62199C27.2779 10.3361 25.3306 11 23.5891 11Z",
    fill: "#077882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingCurveLine);
export default __webpack_public_path__ + "static/media/landing_curve_line.4a1dd258eaba268149921c46bb484709.svg";
export { ForwardRef as ReactComponent };